import moment from "moment-timezone";
import Modal from "../Modal";
import {
  CircularProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { useEffect, useState } from "react";
import { sendGetRequest } from "../../utils";

const RATING_POINTS = 3;

const EmployeePoints = ({ open, onClose, employee, filters }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [employeeRatings, setEmployeeRatings] = useState([]);

  const fetchEmployeeRatings = async () => {
    try {
      setIsLoading(true);
      const resp = await sendGetRequest(
        `employees/ratings?employee_id=${employee.id}&start_date=${filters.start_date}&end_date=${filters.end_date}`,
        true
      );
      const data = await resp.json();
      setEmployeeRatings(data);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (employee && employee?.id) {
      setEmployeeRatings([]);
      fetchEmployeeRatings();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [employee, filters]);

  return (
    <Modal
      open={open}
      handleClose={onClose}
      style={{ width: "620px", backgroundColor: "#f5f5f5" }}
    >
      <div className="flex flex-col gap-4">
        <h1 className="text-xl font-bold">
          Employee Points{" "}
          <span className="font-normal">
            ({moment(filters.start_date).format("DD/MM/YYYY")} -{" "}
            {moment(filters.end_date).format("DD/MM/YYYY")})
          </span>
        </h1>
        <div className="space-y-2">
          <TableContainer component={Paper} sx={{ maxHeight: "400px" }}>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell>Date</TableCell>
                  <TableCell className="!text-center">Cleanliness</TableCell>
                  <TableCell className="!text-center">Reliability</TableCell>
                  <TableCell className="!text-center">Fun</TableCell>
                  <TableCell>Given By</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {isLoading && (
                  <TableRow>
                    <TableCell colSpan={5} className="!text-center">
                      <CircularProgress />
                    </TableCell>
                  </TableRow>
                )}
                {employeeRatings.map((rating) => (
                  <TableRow key={rating.id}>
                    <TableCell>
                      {moment(rating.created_at).format("YYYY-MM-DD")}
                    </TableCell>
                    <TableCell className="!text-center">
                      {rating.cleanliness * RATING_POINTS}
                    </TableCell>
                    <TableCell className="!text-center">
                      {rating.reliability * RATING_POINTS}
                    </TableCell>
                    <TableCell className="!text-center">
                      {rating.fun * RATING_POINTS}
                    </TableCell>
                    <TableCell>
                      {rating.customer_uuid ? (
                        <span className="text-gray-500">Customer</span>
                      ) : (
                        `${rating.first_name} ${rating.last_name}`
                      )}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      </div>
    </Modal>
  );
};

export default EmployeePoints;
